<template>
  <div class="overflow-y-scroll">
    <section>
      <div class="form-inline flex-row">
        <label>Company Name:</label>
        <div class="input-group">
          <input
            type="text"
            placeholder="Company Name"
            v-model="editCompanyName"
          />
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Location:</label>
        <div class="input-group">
          <input type="text" placeholder="Location" v-model="editLocation" />
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Image Url:</label>
        <div class="input-group">
          <input type="text" placeholder="Image Url" v-model="editImageUrl" />
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>From:</label>
        <VueCtkDateTimePicker
          v-model="editStartTime"
          :max-date="editEndTime"
          :no-label="false"
          :only-date="true"
          :auto-close="true"
          :no-value-to-custom-elem="true"
          :right="true"
          format="YYYY-MM-DD"
          formatted="ll"
        >
          <input type="text" :value="editStartTime" placeholder="Select Date" />
        </VueCtkDateTimePicker>
      </div>
      <div class="form-inline flex-row">
        <label>To:</label>
        <div>
          <VueCtkDateTimePicker
            v-model="editEndTime"
            :min-date="editStartTime"
            :no-label="false"
            :only-date="true"
            :auto-close="true"
            :no-value-to-custom-elem="true"
            :right="true"
            format="YYYY-MM-DD"
            formatted="ll"
          >
            <input type="text" :value="editEndTime" placeholder="Select Date" />
          </VueCtkDateTimePicker>
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Job:</label>
        <div class="input-group">
          <input type="text" placeholder="Job" v-model="editJob" />
        </div>
      </div>
      <div class="form-inline">
        <label>Experiences:</label>
        <div
          class="input-group input-prepend input-append"
          v-for="(experience, index) in editExperiences"
          :key="index"
        >
          <textarea
            rows="3"
            placeholder="experience"
            v-model="editExperiences[index]"
          />
          <a
            href="javascript:void(0)"
            class="input-prepend-btn"
            @click="addExperience(index)"
          >
            <i class="material-icons-outlined align-middle">add</i>
          </a>
          <a
            href="javascript:void(0)"
            class="input-apend-btn"
            @click="deleteExperience(index)"
          >
            <i class="material-icons-outlined align-middle">delete</i>
          </a>
        </div>
      </div>
      <div class="form-inline flex-row">
        <button class="submit primary" @click="onButtonClick">
          {{ buttonLabel }}
        </button>
      </div>
    </section>
  </div>
</template>

<script>
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import { dateformat } from "@/utils/utils";
import moment from "moment";
export default {
  props: ["workHistory", "index", "type"],
  components: { VueCtkDateTimePicker },
  watch: {
    workHistory: function () {
      this.initData();
    },
    type: function () {
      this.initData();
    },
  },
  data() {
    return {
      panelTitle: null,
      buttonLabel: null,
      editCompanyName: null,
      editLocation: null,
      editImageUrl: null,
      editStartTime: null,
      editEndTime: null,
      editJob: null,
      editExperiences: null,
      tier_prediction_from_desc: null,
      tier_prediction_from_title: null,
      yn_prediction_from_title: null,
    };
  },
  created: function () {
    this.initData();
  },
  methods: {
    addExperience: function (index) {
      this.editExperiences.splice(index + 1, 0, "");
    },
    deleteExperience: function (index) {
      this.editExperiences.splice(index, 1);
      if (this.editExperiences.length == 0) {
        this.editExperiences.push("");
      }
    },
    initData: function () {
      if (this.type == "edit") {
        this.panelTitle = this.buttonLabel = "Edit Work History";
        this.editCompanyName = this.workHistory.company_name;
        this.editLocation = this.workHistory.location;
        this.editImageUrl = this.workHistory.image_url;
        this.editStartTime = dateformat(
          this.workHistory.start_time,
          "YYYY-MM-DD"
        );
        this.editEndTime = dateformat(this.workHistory.end_time, "YYYY-MM-DD");
        this.editJob = this.workHistory.job;
        this.editExperiences = Object.assign(
          [""],
          this.workHistory.experiences
        );
        this.tier_prediction_from_desc =
          this.workHistory.tier_prediction_from_desc;
        this.tier_prediction_from_title =
          this.workHistory.tier_prediction_from_title;
        this.yn_prediction_from_title =
          this.workHistory.yn_prediction_from_title;
      } else if (this.type == "add") {
        this.panelTitle = this.buttonLabel = "Add Work History";
        this.editCompanyName =
          this.editLocation =
          this.editImageUrl =
          this.editStartTime =
          this.editEndTime =
          this.editJob =
            null;
        this.editExperiences = [""];
      }
    },
    onButtonClick: function () {
      const dataExperiences = [];
      this.editExperiences.forEach((item) => {
        if (item) {
          dataExperiences.push(item);
        }
      });
      const data = {
        company_name: this.editCompanyName ? this.editCompanyName : null,
        location: this.editLocation ? this.editLocation : null,
        image_url: this.editImageUrl ? this.editImageUrl : null,
        start_time: this.editStartTime
          ? moment(this.editStartTime).valueOf() / 1000
          : null,
        end_time: this.editEndTime
          ? moment(this.editEndTime).valueOf() / 1000
          : null,
        job: this.editJob ? this.editJob : null,
        experiences: dataExperiences,
        tier_prediction_from_desc: this.tier_prediction_from_desc
          ? this.tier_prediction_from_desc
          : null,
        tier_prediction_from_title: this.tier_prediction_from_title
          ? this.tier_prediction_from_title
          : null,
        yn_prediction_from_title: this.yn_prediction_from_title
          ? this.yn_prediction_from_title
          : null,
      };
      this.$emit("onButtonClick", data, this.type, this.index);
    },
  },
};
</script>
